import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    // Ponto de presença. Ocupa os mesmos 20 px do ícone antigo para não
    // desalinhar quem o usa ao lado do nome (chat interno, transferências…).
    dot: {
      display: "inline-block",
      flex: "none",
      width: 10,
      height: 10,
      margin: "0 5px",
      borderRadius: "50%",
      verticalAlign: "middle",
    },
    on: { backgroundColor: t.semantic.success },
    off: { backgroundColor: t.textMuted },
  };
});

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();
  if (!user) {
    return null;
  }
  const online = user.online === true;
  const label = online ? "Online" : "Offline";
  return (
    <Tooltip title={label}>
      <span
        role="img"
        aria-label={label}
        className={`${classes.dot} ${online ? classes.on : classes.off}`}
      />
    </Tooltip>
  );
};

export default UserStatusIcon;
